module.exports = {
  VALMEEGO_COM_THE_HOME_OF_TRI: "VALMEEGO_COM_THE_HOME_OF_TRI",
  USER_DETAILS: "USER_DETAILS",
  ID: "ID",
  NAME: "NAME",
  EMAIL: "EMAIL",
  EMAIL_VERIFIED_AT: "EMAIL_VERIFIED_AT",
  CREATED_AT: "CREATED_AT",
  UPDATED_AT: "UPDATED_AT",
  DISABLED: "DISABLED",
  BACK_TO_USER_LIST: "BACK_TO_USER_LIST",
  _: "_",
  MESSAGE_AMEEGO: "MESSAGE_AMEEGO",
  REP_OF_IRELAND: "REP_OF_IRELAND",
  LANGUAGES: "LANGUAGES",
  QUALIFICATIONS: "QUALIFICATIONS",
  QUALIFICATIONS_GO_HERE: "QUALIFICATIONS_GO_HERE",
  RATINGS: "RATINGS",
  ENTER_A_NEW_PASSWORD: "ENTER_A_NEW_PASSWORD",
  RETYPE_PASSWORD: "RETYPE_PASSWORD",
  VERIFICATION_CODE_SENT_TO: "VERIFICATION_CODE_SENT_TO",
  ENTER_CODE: "ENTER_CODE",
  SIGNING_YOU_IN_TAKING_TOO_LON: "SIGNING_YOU_IN_TAKING_TOO_LON",
  LOGIN: "LOGIN",
  SERVICE: "SERVICE",
  _1: "_1",
  AMOUNT: "AMOUNT",
  _2: "_2",
  DATE: "DATE",
  _3: "_3",
  MESSAGE: "MESSAGE",
  VALMEEGO_IS_A_PLATFORM_FOR_TRI: "VALMEEGO_IS_A_PLATFORM_FOR_TRI",
  VALMEEGO_COMBINES_LOCAL_EXPERT: "VALMEEGO_COMBINES_LOCAL_EXPERT",
  PERSONAL_RECOMMENDATIONS_FROM: "PERSONAL_RECOMMENDATIONS_FROM",
  XS: "XS",
  ENTER_YOUR_ACCESS_CODE: "ENTER_YOUR_ACCESS_CODE",
  OFF: "OFF",
  CODE: "CODE",
  ENTER: "ENTER",
  _4: "_4",
  WRONG_PASSWORD_PLEASE_TRY_AGA: "WRONG_PASSWORD_PLEASE_TRY_AGA",
  SUBMIT: "SUBMIT",
  CODE_SUBMIT: "CODE_SUBMIT",
  GERARD_BUTTERLY: "GERARD_BUTTERLY",
  GERARD_BUTTERLY_VALMEEGO_COM: "GERARD_BUTTERLY_VALMEEGO_COM",
  GET_IN_TOUCH: "GET_IN_TOUCH",
  ADDED: "ADDED",
  BE_FIRST_IN_LINE: "BE_FIRST_IN_LINE",
  _5: "_5",
  LATEST_VERSION: "LATEST_VERSION",
  KEEP_ME_UP_TO_DATE: "KEEP_ME_UP_TO_DATE",
  DON_T_WORRY_WE_WON_T_SEND_YOU: "DON_T_WORRY_WE_WON_T_SEND_YOU",
  CREATE_QUOTE: "CREATE_QUOTE",
  INTERNAL_REFERENCE: "INTERNAL_REFERENCE",
  PRICE: "PRICE",
  DESCRIPTION: "DESCRIPTION",
  RATE_THIS_SERVICE: "RATE_THIS_SERVICE",
  RATING: "RATING",
  DESCRIBE_YOUR_EXPERIENCE: "DESCRIBE_YOUR_EXPERIENCE",
  THERE_IS_NO_TRIP_ASSOCIATED_WI: "THERE_IS_NO_TRIP_ASSOCIATED_WI",
  ADMIN_MENU: "ADMIN_MENU",
  DASHBOARD: "DASHBOARD",
  TRIPS: "TRIPS",
  USERS: "USERS",
  SERVICE_PROVIDERS: "SERVICE_PROVIDERS",
  DMO: "DMO",
  PRO_PLANNERS: "PRO_PLANNERS",
  TRIP_PLANNERS: "TRIP_PLANNERS",
  NEWSLETTER: "NEWSLETTER",
  INVITE: "INVITE",
  FOR_EXAMPLE: "FOR_EXAMPLE",
  RATE_YOUR_AMEEGO: "RATE_YOUR_AMEEGO",
  DRAG_AND_DROP_FILES_FOR_UPLOAD: "DRAG_AND_DROP_FILES_FOR_UPLOAD",
  OR: "OR",
  COMPATIBLE_FORMATS: "COMPATIBLE_FORMATS",
  _6: "_6",
  UH_OH: "UH_OH",
  THERE_S_NOTHING_HERE: "THERE_S_NOTHING_HERE",
  ERROR: "ERROR",
  UH_OH_THERE_S_NOTHING_HERE: "UH_OH_THERE_S_NOTHING_HERE",
  RETURN_TO_HOME: "RETURN_TO_HOME",
  INVITATIONS: "INVITATIONS",
  EDIT_AMEEGO_PROFILE: "EDIT_AMEEGO_PROFILE",
  PARTICIPANT: "PARTICIPANT",
  S: "S",
  REJECT: "REJECT",
  APPLICATION_JSON: "APPLICATION_JSON",
  FAILED_TO_LOAD: "FAILED_TO_LOAD",
  DMO_DETAILS: "DMO_DETAILS",
  URL: "URL",
  AREA: "AREA",
  DESCRIPTION1: "DESCRIPTION1",
  BACK_TO_SERVICE_PROVIDER_LIST: "BACK_TO_SERVICE_PROVIDER_LIST",
  USERS_CONNECTED: "USERS_CONNECTED",
  USERS_REGISTERED: "USERS_REGISTERED",
  DAU: "DAU",
  DAU_VS_TOTAL_REGISTERED: "DAU_VS_TOTAL_REGISTERED",
  MESSAGES: "MESSAGES",
  GROWTH_RATE_MESSAGES_DAY: "GROWTH_RATE_MESSAGES_DAY",
  CREATED_TRIPS: "CREATED_TRIPS",
  GROWTH_RATE_TRIPS_DAY: "GROWTH_RATE_TRIPS_DAY",
  TRIP_PLANNERS1: "TRIP_PLANNERS1",
  GROWTH_RATE_PLANNERS_DAY: "GROWTH_RATE_PLANNERS_DAY",
  AMEEGOS: "AMEEGOS",
  GROWTH_RATE_AMEEGOS_DAY: "GROWTH_RATE_AMEEGOS_DAY",
  SERVICE_PROVIDERS1: "SERVICE_PROVIDERS1",
  GROWTH_RATE_SERVICE_PROVIDERS: "GROWTH_RATE_SERVICE_PROVIDERS",
  INVITES_VS_TRIPS_CREATED: "INVITES_VS_TRIPS_CREATED",
  TRIPS_WITH_AMEEGOS: "TRIPS_WITH_AMEEGOS",
  TRIPS_WITH_BOOKINGS: "TRIPS_WITH_BOOKINGS",
  GROWTH_RATE_TRIPS_BOOKINGS: "GROWTH_RATE_TRIPS_BOOKINGS",
  VALUE_BOOKINGS_MEAN: "VALUE_BOOKINGS_MEAN",
  VALUE_BOOKINGS_MEDIAN: "VALUE_BOOKINGS_MEDIAN",
  INVITE_USERS: "INVITE_USERS",
  NAME1: "NAME1",
  USER_TYPE: "USER_TYPE",
  LANGSELECT: "LANGSELECT",
  LANGS: "LANGS",
  TYPESELECT: "TYPESELECT",
  LALA: "LALA",
  SUCCESS: "SUCCESS",
  SUCCESS1: "SUCCESS1",
  INVITE_HAS_BEEN_SENT: "INVITE_HAS_BEEN_SENT",
  TRIP_PLANNER: "TRIP_PLANNER",
  AMEEGO: "AMEEGO",
  SERVICE_PROVIDER: "SERVICE_PROVIDER",
  PRO_TRIP_PLANNER: "PRO_TRIP_PLANNER",
  BUSINESS_NAME: "BUSINESS_NAME",
  INTEREST_LOCAL_ADVISOR: "INTEREST_LOCAL_ADVISOR",
  INTEREST_TRAVEL_BUSINESS: "INTEREST_TRAVEL_BUSINESS",
  SERVICE_PROVIDER_DETAILS: "SERVICE_PROVIDER_DETAILS",
  PHONE: "PHONE",
  CONTENT_GOES_HERE: "CONTENT_GOES_HERE",
  KEY_PROBLEMS: "KEY_PROBLEMS",
  WISH_LIST: "WISH_LIST",
  BACK_TO_TRIP_PLANNER_LIST: "BACK_TO_TRIP_PLANNER_LIST",
  ERROR1: "ERROR1",
  WHAT_ARE_AMEEGOS: "WHAT_ARE_AMEEGOS",
  AMEEGOS_ARE_EXPERT_LOCAL_AND_T: "AMEEGOS_ARE_EXPERT_LOCAL_AND_T",
  AMEEGOS_PROVIDE_EXPERT_LOCAL_A: "AMEEGOS_PROVIDE_EXPERT_LOCAL_A",
  ENGAGING_AN_AMEEGO_SAVES_TIME: "ENGAGING_AN_AMEEGO_SAVES_TIME",
  CHOOSE_THE_MOST_RELEVANT_AMEEG: "CHOOSE_THE_MOST_RELEVANT_AMEEG",
  AMEEGOS_WORK_SOLELY_FOR_THOSE: "AMEEGOS_WORK_SOLELY_FOR_THOSE",
  AMEEGOS_CANNOT_SEE_YOUR_GROUP: "AMEEGOS_CANNOT_SEE_YOUR_GROUP",
  API_FILE: "API_FILE",
  API_FILE1: "API_FILE1",
  POST: "POST",
  MY_TRIPS: "MY_TRIPS",
  WELCOME_COMPONENT_TO_GO_HERE: "WELCOME_COMPONENT_TO_GO_HERE",
  NIGHT: "NIGHT",
  NIGHTS: "NIGHTS",
  GOING: "GOING",
  _7: "_7",
  MY_PHOTOS: "MY_PHOTOS",
  REM: "REM",
  SERVICES: "SERVICES",
  MY_NOTIFICATIONS: "MY_NOTIFICATIONS",
  BUTTON_CHOOSE_AMEEGO: "BUTTON_CHOOSE_AMEEGO",
  CHOOSE: "CHOOSE",
  FOR_YOUR_TRIP: "FOR_YOUR_TRIP",
  ERROR2: "ERROR2",
  THIS_WILL_COST_X_PER_TRAVELLER: "THIS_WILL_COST_X_PER_TRAVELLER",
  YOU_HAVE_INVITED: "YOU_HAVE_INVITED",
  PARTICIPANTS: "PARTICIPANTS",
  INVITE_SOMEONE_NEW: "INVITE_SOMEONE_NEW",
  NAME2: "NAME2",
  SURNAME: "SURNAME",
  PHONE1: "PHONE1",
  SEND_INVITE: "SEND_INVITE",
  INVITED: "INVITED",
  REJECTED: "REJECTED",
  APP_TRIP: "APP_TRIP",
  PARTICIPANTS1: "PARTICIPANTS1",
  VIEW_ITINERARY: "VIEW_ITINERARY",
  TRIP_CHAT: "TRIP_CHAT",
  ADD_AN_AMEEGO: "ADD_AN_AMEEGO",
  WHAT_IS_AN_AMEEGO: "WHAT_IS_AN_AMEEGO",
  AMEEGO_CHAT: "AMEEGO_CHAT",
  RATE_YOUR_AMEEGO1: "RATE_YOUR_AMEEGO1",
  VIEW_SERVICES_NEAR: "VIEW_SERVICES_NEAR",
  TRIP_FINANCES: "TRIP_FINANCES",
  TRIP_AMEEGO: "TRIP_AMEEGO",
  LEAVE_THIS_TRIP: "LEAVE_THIS_TRIP",
  BACKGROUND_IMAGE: "BACKGROUND_IMAGE",
  API_IMAGE: "API_IMAGE",
  ENTER_A_SECURE_PASSWORD_TO_PRO: "ENTER_A_SECURE_PASSWORD_TO_PRO",
  YOUR_PASSWORD_SHOULD: "YOUR_PASSWORD_SHOULD",
  BE_AT_LEAST_X_CHARACTERS_LONG: "BE_AT_LEAST_X_CHARACTERS_LONG",
  ETC: "ETC",
  BACK_TO_LOGIN: "BACK_TO_LOGIN",
  TROUBLE_LOGGING_IN: "TROUBLE_LOGGING_IN",
  ENTER_YOUR_EMAIL_ADDRESS: "ENTER_YOUR_EMAIL_ADDRESS",
  YOU_HAVE_BEEN_SUBSCRIBED: "YOU_HAVE_BEEN_SUBSCRIBED",
  ENTER_YOUR_EMAIL_ADDRESS_BELOW: "ENTER_YOUR_EMAIL_ADDRESS_BELOW",
  NEWSLETTER1: "NEWSLETTER1",
  PLEASE_ENTER_A_VALID_EMAIL_ADD: "PLEASE_ENTER_A_VALID_EMAIL_ADD",
  EMAIL1: "EMAIL1",
  NEWSLETTER_EMAIL: "NEWSLETTER_EMAIL",
  ENTER_YOUR_EMAIL_ADDRESS1: "ENTER_YOUR_EMAIL_ADDRESS1",
  WE_DON_T_SPAM_OR_SHARE_YOUR_AD: "WE_DON_T_SPAM_OR_SHARE_YOUR_AD",
  NEWSLETTER_SUBSCRIBE: "NEWSLETTER_SUBSCRIBE",
  HI: "HI",
  WELCOME_TO: "WELCOME_TO",
  HAS_INVITED_YOU_TO: "HAS_INVITED_YOU_TO",
  VERIFY_NUMBER: "VERIFY_NUMBER",
  WE_WILL_SEND_YOU_AN_SMS_CODE_T: "WE_WILL_SEND_YOU_AN_SMS_CODE_T",
  SEND_ME_CODE: "SEND_ME_CODE",
  EMAIL2: "EMAIL2",
  ENTER_SMS_CODE: "ENTER_SMS_CODE",
  NAME3: "NAME3",
  SURNAME1: "SURNAME1",
  PHONE2: "PHONE2",
  EMAIL3: "EMAIL3",
  WHAT_AREA_DOES_YOUR_DMO_PROMOT: "WHAT_AREA_DOES_YOUR_DMO_PROMOT",
  WHAT_ARE_YOUR_KEY_PROBLEMS_IN: "WHAT_ARE_YOUR_KEY_PROBLEMS_IN",
  SUBMIT1: "SUBMIT1",
  YOU_HAVE_BEEN_REGISTERED: "YOU_HAVE_BEEN_REGISTERED",
  WELCOME_TO1: "WELCOME_TO1",
  PLEASE_ENTER_YOUR_DETAILS: "PLEASE_ENTER_YOUR_DETAILS",
  BUSINESS_NAME1: "BUSINESS_NAME1",
  WEBSITE: "WEBSITE",
  SERVICE_OR_PRODUCT_DESCRIPTION: "SERVICE_OR_PRODUCT_DESCRIPTION",
  FIRST_NAME: "FIRST_NAME",
  YOUR_KEY_PROBLEMS_WHEN_ORGANIS: "YOUR_KEY_PROBLEMS_WHEN_ORGANIS",
  YOUR_TOP_WISH_LIST_COUNTRIE: "YOUR_TOP_WISH_LIST_COUNTRIE",
  FAMILY_NAME: "FAMILY_NAME",
  WEBSITE1: "WEBSITE1",
  PLEASE_CHECK_ALL_THAT_APPLY: "PLEASE_CHECK_ALL_THAT_APPLY",
  I_AM_INTERESTED_IN_VALMEEGO_FO: "I_AM_INTERESTED_IN_VALMEEGO_FO",
  I_AM_INTERESTED_IN_VALMEEGO_AS: "I_AM_INTERESTED_IN_VALMEEGO_AS",
  PAGES_IN_STORYBOOK: "PAGES_IN_STORYBOOK",
  WE_RECOMMEND_BUILDING_UIS_WITH: "WE_RECOMMEND_BUILDING_UIS_WITH",
  COMPONENT_DRIVEN: "COMPONENT_DRIVEN",
  PROCESS_STARTING_WITH_ATOMIC_C: "PROCESS_STARTING_WITH_ATOMIC_C",
  RENDER_PAGES_WITH_MOCK_DATA_T: "RENDER_PAGES_WITH_MOCK_DATA_T",
  USE_A_HIGHER_LEVEL_CONNECTED_C: "USE_A_HIGHER_LEVEL_CONNECTED_C",
  ASSEMBLE_DATA_IN_THE_PAGE_COMP: "ASSEMBLE_DATA_IN_THE_PAGE_COMP",
  GET_A_GUIDED_TUTORIAL_ON_COMPO: "GET_A_GUIDED_TUTORIAL_ON_COMPO",
  STORYBOOK_TUTORIALS: "STORYBOOK_TUTORIALS",
  READ_MORE_IN_THE: "READ_MORE_IN_THE",
  DOCS: "DOCS",
  TIP: "TIP",
  ADJUST_THE_WIDTH_OF_THE_CANVAS: "ADJUST_THE_WIDTH_OF_THE_CANVAS",
  VIEWPORTS_ADDON_IN_THE_TOOLBAR: "VIEWPORTS_ADDON_IN_THE_TOOLBAR",
  OFFLINE: "OFFLINE",
  OFFLINE_DESCRIPTION: "OFFLINE_DESCRIPTION",
  GO_BACK: "GO_BACK",
  AMEEGO_IS_VERIFIED: "AMEEGO_IS_VERIFIED",
  AMEEGO_NOT_VERIFIED: "AMEEGO_NOT_VERIFIED",
  SEND_AN_INVITE: "SEND_AN_INVITE",
  VIEW_BOOKINGS: "VIEW_BOOKINGS",
  HOME: "HOME",
  AMEEGO_INVITE_EXPLANATION: "AMEEGO_INVITE_EXPLANATION",
  COOKIE_BANNER: "COOKIE_BANNER",
  COOKIE_ACCEPT: "COOKIE_ACCEPT",
  EXAMPLE_TELEPHONE: "EXAMPLE_TELEPHONE",
  SETTINGS: "SETTINGS",
  SPEAKS: "SPEAKS",
  ITINERARY_TITLE_AND_DETAILS: "ITINERARY_TITLE_AND_DETAILS",
  HAS_INVITED_YOU_TO_HAVE_A_LOOK: "HAS_INVITED_YOU_TO_HAVE_A_LOOK",
  UPCOMING_TRIP_BOOKINGS: "UPCOMING_TRIP_BOOKINGS",
};
